var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$slots.btns),expression:"$slots.btns"}],staticClass:"btn-box"},[_vm._t("btns")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }